import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    additionalDataColumnText: {
        color: theme.palette.grey.dark,
        marginRight: '10px',
        width: '35%'
    },
    dataColumn: {
        width: '300px'
    },
    dataColumnLegend: {
        marginTop: '40px',
        width: '100px'
    },
    dataColumnLegendText: {
        alignItems: 'center',
        color: theme.palette.grey.dark,
        display: 'flex',
        height: '40px',
        marginBottom: '5px',
        width: '100%'
    },
    dataColumnText: {
        alignItems: 'center',
        display: 'flex',
        height: '40px',
        justifyContent: 'space-between',
        marginBottom: '5px',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%'
    },
    dataColumnTitle: {
        fontSize: '15px',
        fontWeight: 'bold',
        height: '40px',
        textAlign: 'center'
    },
    dataDialogContent: {
        height: 'calc(100% - 500px)',
        minHeight: '400px',
        maxWidth: 'calc(100% - 100px)',
        width: '1200px'
    },
    dataDialogTextField: {
        marginBottom: '7.5px',
        width: '100%'
    },
    dataDialogTitle: {
        alignItems: 'center',
        display: 'flex',
        paddingBottom: '0px'
    },
    dataDialogTitleText: {
        maxWidth: '40%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    dataDialogTitleTextContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: '10px',
        width: 'calc(100% - 30px)'
    },
    dataTabs: {
        marginBottom: '15px'
    },
    dataUrl: {
        '&:hover': {
            backgroundColor: theme.palette.grey.ultralight
        },
        borderRadius: '5px',
        color: theme.palette.grey.dark,
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '400',
        maxWidth: '55%',
        overflow: 'hidden',
        paddingLeft: '2px',
        paddingRight: '2px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '0px',
        paddingTop: '15px !important'
    },
    footerText: {
        display: 'flex',
        flexDirection: 'column'
    },
    infoText: {
        color: theme.palette.blue.light,
        fontSize: '0.8em',
        maxWidth: '260px'
    },
    mpColumnLegend: {
        marginTop: '40px',
        width: '150px'
    },
    mpColumnLegendText: {
        alignItems: 'center',
        color: theme.palette.grey.dark,
        display: 'flex',
        height: '20px',
        marginBottom: '5px',
        width: '100%'
    },
    mpColumnText: {
        height: '20px',
        marginBottom: '5px',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    mpDialogTextField: {
        width: '100%'
    },
    mpEditColumnLegendText: {
        alignItems: 'center',
        color: theme.palette.grey.dark,
        display: 'flex',
        height: '40px',
        marginBottom: '5px',
        width: '100%'
    },
    mpEditColumnText: {
        alignItems: 'center',
        display: 'flex',
        height: '40px',
        marginBottom: '5px',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    otherData: {
        display: 'flex',
        height: '50px',
        justifyContent: 'space-between',
        paddingTop: '30px'
    },
    otherDataIcon: {
        marginTop: '22px',
        padding: '0px'
    },
    otherDataText: {
        color: theme.palette.grey.dark
    },
    select: {
        marginTop: '10px'
    }
}));

export default useStyles;
